import logoStage from "../img/logos/Matrix6.png";
import logoErna from "../img/logos/ERNA LOGO.png";
import logoNml from "../img/logos/nml.png";
import logoAotai from "../img/logos/aotai.jpg.webp";

export const VISIT_CARD_LOGOS = {
  stage: { src: logoStage, wide: false, label: "STAGE DESIGN" },
  erna: { src: logoErna, wide: true, label: "ERNA TRADE" },
  nml: { src: logoNml, wide: true, lightBg: true, label: "NML" },
  aotai: { src: logoAotai, wide: true, lightBg: true, label: "Jiashan Aotai" },
};

export function visitCardLogo(logoKey, company = {}) {
  const key = String(logoKey || "").trim().toLowerCase();
  if (key && key !== "stage" && VISIT_CARD_LOGOS[key]) return VISIT_CARD_LOGOS[key];
  const haystack = `${company.slug || ""} ${company.name || ""}`.toLowerCase();
  if (haystack.includes("aotai")) return VISIT_CARD_LOGOS.aotai;
  if (VISIT_CARD_LOGOS[key]) return VISIT_CARD_LOGOS[key];
  return VISIT_CARD_LOGOS.stage;
}

export function resolvedVisitCardLogoKey(logoKey, company = {}) {
  const logo = visitCardLogo(logoKey, company);
  return (
    Object.keys(VISIT_CARD_LOGOS).find((key) => VISIT_CARD_LOGOS[key] === logo) ||
    "stage"
  );
}
